import styled from 'foundations-theming/utils';
import { LockedIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "TimelineUpgradePoint__Container",
  componentId: "sc-1l2mmc4-0"
})(["align-items:center;background:", ";display:flex;justify-content:center;margin:", ";padding:", ";width:auto;"], ({
  theme
}) => theme.color['fill-accent-orange-hover'], ({
  theme
}) => `${theme.space['0']} ${theme.space['400']}`, ({
  theme
}) => `${theme.space['200']} ${theme.space['400']}`);
const Title = styled.span.withConfig({
  displayName: "TimelineUpgradePoint__Title",
  componentId: "sc-1l2mmc4-1"
})(["font-weight:", ";"], ({
  theme
}) => theme.typography['heading-600'].fontWeight);
const TimelineUpgradePoint = ({
  loading
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('activity-limit-upgrade-point');
  if (loading) {
    return null;
  }
  const titleText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "timeline.activityLimitUpgrade.title"
  });
  const subtext = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "timeline.activityLimitUpgrade.subtitle"
  });
  const button = /*#__PURE__*/_jsx(Link, {
    onClick: openUpgradeModal,
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "timeline.activityLimitUpgrade.upgrade"
    })
  });
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsxs(Container, {
      "data-test-id": "activity-limit-upgrade-point",
      role: "alert",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(LockedIcon, {
          size: "600",
          color: "fill-primary-default"
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Title, {
          role: "heading",
          children: titleText
        }), "\xA0", subtext, "\xA0", button]
      })]
    })
  );
};
export default TimelineUpgradePoint;